// eslint-disable no-unused-prop-types
import React from 'react'
import { Box, Snackbar as MUISnackbar, Typography } from '@mui/material'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'

/*
Copyright 2022-06-17 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: se agregan íconoso solicitados por UX/UI
*/

interface SnackbarProps {
  open: boolean
  setOpen?: any
  message: string
  status: string
  autoHideDuration?: number
}

export const SnackBar: React.FC<SnackbarProps> = ({
  open,
  setOpen,
  message,
  status,
  autoHideDuration = 3000
}) => {
  const handleClose = (_event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return
    }

    if (setOpen) {
      setOpen(false)
    }
  }

  return (
    <Box
      sx={(theme) => ({
        width: '100%',
        '& > * + *': {
          marginTop: theme.spacing(2)
        }
      })}
    >
      <MUISnackbar
        open={open}
        autoHideDuration={autoHideDuration}
        onClose={handleClose}
        style={{ borderRadius: '15px' }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert message={message} status={status} />
      </MUISnackbar>
    </Box>
  )
}

interface AlertProps {
  message: string
  status: string
}

const Alert: React.FC<AlertProps> = ({ message, status }) => {
  const baseStyles: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignContent: 'center',
    padding: '20px',
    color: 'white',
    borderRadius: '8px'
  }
  const statusStyles: Record<string, React.CSSProperties> = {
    error: { ...baseStyles, backgroundColor: '#DC0404' },
    success: { ...baseStyles, backgroundColor: '#199D03' },
    errorrelocate: {
      position: 'fixed',
      bottom: '10vw',
      left: '50%',
      transform: 'translateX(-50%)',
      backgroundColor: '#DC0404',
      color: 'white',
      borderRadius: '8px',
      padding: '16px 24px',
      zIndex: 3000,
      width: '68vw',
      maxWidth: '400px',
      textAlign: 'center',
      boxShadow: '0px 4px 12px rgba(0,0,0,0.2)'
    }
  }
  const style = statusStyles[status] || baseStyles
  return (
    <Box sx={style}>
      <Box sx={{ margin: '0px 4px' }}>
        {status === 'error' && <HighlightOffIcon />}
        {status === 'success' && <CheckCircleOutlineIcon />}
      </Box>
      <Typography variant='button'>{message}</Typography>
    </Box>
  )
}
